import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "matching-filters__toggle-wrapper" }
const _hoisted_2 = { class: "matching-filters__filters-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "matching-filters__filters-title" }, "Filters", -1)
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row","align-items":"center","justify-content":"flex-start","gap":"8px"} }
const _hoisted_5 = { class: "slider-demo-block" }
const _hoisted_6 = {
  divider: "",
  style: {"display":"flex","justify-content":"flex-end","gap":"8px","padding-top":"10px","padding-bottom":"10px"}
}
const _hoisted_7 = { class: "matching-filters__search-wrapper" }
const _hoisted_8 = { class: "matching-filters__wrapper" }
const _hoisted_9 = { class: "form-grid form-grid--centered" }
const _hoisted_10 = { class: "matching-filters__label" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTag = _resolveComponent("ElTag")!
  const _component_ElSlider = _resolveComponent("ElSlider")!
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")!
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")!
  const _component_ElDropdown = _resolveComponent("ElDropdown")!
  const _component_ElCheckbox = _resolveComponent("ElCheckbox")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_NetworksSelector = _resolveComponent("NetworksSelector")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_PxFormModal = _resolveComponent("PxFormModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'matching-filters--closed': !_ctx.filtersOpened }, "matching-filters"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ElDropdown, {
              placement: "bottom-start",
              "hide-on-click": false
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElDropdownItem, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_ElSlider, {
                            modelValue: _ctx.vilLevel,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vilLevel) = $event)),
                            max: 6,
                            min: 1,
                            step: 1,
                            range: "",
                            "show-stops": "",
                            marks: {
                        1: '1',
                        2: '2',
                        3: '3',
                        4: '4',
                        5: '5',
                        6: '6',
                      }
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ElTag, {
                  type: "primary",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Level (VIL)")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ElDropdown, {
              placement: "bottom-start",
              "hide-on-click": false
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.matchingSearch.facets.countries
                    ?.options, (facet) => {
                      return (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: facet.value
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_ElCheckbox, {
                            key: facet.value,
                            label: `${facet.label} (${facet.count})`,
                            "model-value": 
                      _ctx.$store.state.matchingSearch.filters.countries.includes(
                        facet.value,
                      )
                    ,
                            onChange: ($event: any) => (_ctx.onHQCountryChange(facet.value))
                          }, null, 8, ["label", "model-value", "onChange"]))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ElTag, {
                        type: "danger",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onHQCountryChange('clear')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Clear All ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ElTag, {
                        type: "danger",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHQCountryChange('all')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Select All ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ElTag, {
                  type: "primary",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" HQ Country " + _toDisplayString(_ctx.country_filter_count > 0 ? "(" + _ctx.country_filter_count + ")" : ""), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ElDropdown, {
              placement: "bottom-start",
              "hide-on-click": false
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.matchingSearch.facets.sectors
                    ?.options, (facet) => {
                      return (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: facet.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElCheckbox, {
                            label: `${facet.label} (${facet.count})`,
                            value: facet.value,
                            "model-value": 
                      _ctx.$store.state.matchingSearch.filters.sectors?.includes(
                        facet.value,
                      )
                    ,
                            onChange: ($event: any) => (_ctx.onSectorsChange(facet.value))
                          }, null, 8, ["label", "value", "model-value", "onChange"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_ElDropdownItem, {
                      divider: "",
                      style: {"display":"flex","justify-content":"flex-end","gap":"8px","padding-top":"10px","padding-bottom":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElTag, {
                          type: "danger",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSectorsChange('all')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Clear All ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ElTag, {
                          type: "danger",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSectorsChange('all')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Select All ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ElTag, {
                  type: "primary",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sectors " + _toDisplayString(_ctx.sector_filter_count > 0 ? "(" + _ctx.sector_filter_count + ")" : ""), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ElDropdown, {
              placement: "bottom-start",
              "hide-on-click": false
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.founding_date_facet, (facet) => {
                      return (_openBlock(), _createBlock(_component_ElDropdownItem, {
                        key: facet.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElCheckbox, {
                            label: `${Math.abs(Number(facet.value)) === 0 ? 'No Founding Date' : facet.value} (${facet.count})`,
                            value: facet.value,
                            "model-value": 
                      _ctx.$store.state.matchingSearch.filters.founding_date?.includes(
                        facet.value,
                      )
                    ,
                            onChange: ($event: any) => (_ctx.onFoundingDateChange(facet.value))
                          }, null, 8, ["label", "value", "model-value", "onChange"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_ElDropdownItem, {
                      divider: "",
                      style: {"display":"flex","justify-content":"flex-end","gap":"8px","padding-top":"10px","padding-bottom":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElTag, {
                          type: "danger",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSectorsChange('all')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Clear All ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ElTag, {
                          type: "danger",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSectorsChange('all')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Select All ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ElTag, {
                  type: "primary",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Founded Date " + _toDisplayString(_ctx.founding_date_filter_count > 0
                  ? "(" + _ctx.founding_date_filter_count + ")"
                  : ""), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ElTag, {
              style: {"cursor":"pointer"},
              type: "danger",
              onClick: _ctx.clearAllFilters
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Clear all filters ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.hasCompaniesSearch)
              ? (_openBlock(), _createBlock(_component_ElInput, {
                  key: 0,
                  modelValue: _ctx.query,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query) = $event)),
                  class: "matching-filters__search",
                  clearable: "",
                  placeholder: "Search for a name, country & sector"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_PxIcon, {
                      size: 24,
                      name: "magnifier"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ElDropdown, { placement: "bottom-start" }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElDropdownItem, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSortChange('desc')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Latest First ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ElDropdownItem, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSortChange('asc')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Oldest First ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ElTag, {
                  type: "primary",
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sort By (" + _toDisplayString(_ctx.sort === "desc" ? "Latest First" : "Oldest First") + ") ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.$user.isSupporter() && _ctx.$screen.mdDown)
              ? (_openBlock(), _createBlock(_component_PxButton, {
                  key: 1,
                  icon: _ctx.$options.static.editCriteriaButton.icon,
                  size: _ctx.$options.static.editCriteriaButton.size,
                  type: _ctx.$options.static.editCriteriaButton.type,
                  variant: _ctx.$options.static.editCriteriaButton.variant,
                  class: "matching-filters__toggle-button",
                  onClick: _ctx.onClickEditCriteria
                }, null, 8, ["icon", "size", "type", "variant", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      (_ctx.$screen.mdUp)
        ? (_openBlock(), _createBlock(_component_ElForm, {
            key: 0,
            ref: "filters",
            model: _ctx.filters
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ElFormItem, { prop: "networks" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`matching.matchingFilters.networks.label`)), 1),
                      _createVNode(_component_ElTooltip, {
                        placement: "top",
                        "popper-class": "matching-filters__tooltip el-abaca-tooltip"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: _ctx.$t('matching.matchingFilters.networks.tip')
                          }, null, 8, _hoisted_11)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_PxIcon, {
                            size: 16,
                            class: "matching-filters__tooltip-icon",
                            name: "question"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_NetworksSelector, {
                      ref: "networkSelector",
                      modelValue: _ctx.filters.network.values,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.network.values) = $event)),
                      "no-label": true,
                      "no-location": true,
                      "placeholder-copy": 
              _ctx.$t(`matching.matchingFilters.networks.placeholder`)
            ,
                      "value-as-instance": true,
                      class: "matching-filters__selector"
                    }, null, 8, ["modelValue", "placeholder-copy"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"]))
        : (_openBlock(), _createBlock(_component_PxFormModal, {
            key: 1,
            title: _ctx.filtersTitle,
            visibility: _ctx.filtersOpened,
            onClose: _ctx.toggleFilters
          }, {
            form: _withCtx(() => [
              _createVNode(_component_ElForm, {
                ref: "filters",
                model: _ctx.filters
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElFormItem, {
                    label: _ctx.$t(`matching.matchingFilters.networks.label`),
                    prop: "networks"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NetworksSelector, {
                        ref: "networkSelector",
                        modelValue: _ctx.filters.network.values,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.network.values) = $event)),
                        "is-modal": true,
                        "no-label": true,
                        "placeholder-copy": 
                _ctx.$t(`matching.matchingFilters.networks.placeholder`)
              ,
                        "value-as-instance": true,
                        class: "matching-filters--mobile__selector"
                      }, null, 8, ["modelValue", "placeholder-copy"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["title", "visibility", "onClose"]))
    ], 512), [
      [_vShow, _ctx.filtersOpened]
    ])
  ], 64))
}